import React from "react";
import doctorImg from "../assets/doctor.jpeg";

const MeetDoctor = () => {
  return (
    <section className="meet-section">
      <h2 className="meet-title">MEET THE DOCTOR</h2>
      <h2 className="underline">_______________</h2>

      <div className="doctor-arch">
        <div className="doctor-image-box">
          <img src={doctorImg} alt="Doctor" />
        </div>

        {/* This wrapper is key for the desktop layout */}
        <div className="doctor-info-container">
          <h3 className="doctor-name">
            DR. SHIVANI M. VETKAR
          </h3>

          <div className="doctor-details">
            <div className="detail-block">
              <h4>Education</h4>
              <p>Degree: BHMS</p>
              <p> MD (HOM) </p>
              <p> CCPH (Certificate course of predictive Homoeopathy)</p>
            </div>
            
            {/* The <br> is kept for mobile, but hidden in CSS for desktop */}
            <br className="mobile-br"></br>

            <div className="detail-block">
              <h4>Residency</h4>
              <p>MUMBAI</p>
              <p>Remote consultancy available</p>
              <p className="contact-text"><strong>Contact : 8097446666</strong></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetDoctor;
